import { CircularProgress, Typography, FormControlLabel, Radio, TextField, outlinedInputClasses, inputClasses } from "@mui/material";
import { styled, css } from "@mui/material/styles";
import { AppointmentState } from "../../../appointment-details/appointment-details.types.js";
const STATE_COLOR_MAP = (theme) => ({
  [AppointmentState.CANCELED]: theme.palette.error[600],
  [AppointmentState.TREATED]: theme.palette.secondary[600],
  [AppointmentState.IN_TREATMENT]: theme.palette.highlight1[600],
  [AppointmentState.IN_TREATMENT_ROOM]: theme.palette.primary[800],
  [AppointmentState.WAITING]: theme.palette.warning[700]
});
const getStateColor = (theme, state) => {
  const map = STATE_COLOR_MAP(theme);
  const mapKeys = Object.keys(map);
  if (mapKeys.includes(state)) {
    return map[state];
  }
};
const LoadingCircle = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary[800],
  width: "24.56px",
  height: "32px",
  position: "absolute"
}));
const RootContainer = styled("div", { shouldForwardProp: (props) => props !== "grey" })`
  width: fill-available;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  vertical-align: center;

  height: 42px;

  ${({ grey }) => grey && css`
      color: rgba(0, 0, 0, 0.26);
    `};
`;
const InputGroup = styled("div")`
  display: flex;
  align-self: center;
  column-gap: ${({ theme }) => theme.spacing(1)};
`;
const StatusLabel = styled(Typography, { shouldForwardProp: (props) => props !== "grey" })`
  color: #424242;
  align-items: center;

  ${({ grey }) => grey && css`
      opacity: 0.2;
    `};
`;
const StatusText = styled(FormControlLabel)`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
const Group = styled("div")``;
const LabelContainer = styled("div")`
  display: flex;
  height: inherit;
`;
const IconContainer = styled("div", {
  shouldForwardProp: (props) => props !== "state"
})(({ theme, state }) => ({
  display: "flex",
  marginRight: theme.spacing(1),
  "&&&&": {
    color: getStateColor(theme, state)
  },
  "&& .MuiSvgIcon-root": {
    fill: "none"
  }
}));
const RadioButton = styled(Radio, {
  shouldForwardProp: (props) => props !== "grey"
})(({ theme, grey }) => ({
  ...grey && {
    opacity: 0.2
  },
  "&&&.Mui-checked": {
    color: theme.palette.primary[800]
  }
}));
const StyledTextField = styled(TextField)(({ theme }) => ({
  padding: 0,
  [`& .${outlinedInputClasses.root}`]: {
    borderRadius: "2px",
    borderColor: theme.palette.grey[600],
    color: theme.palette.grey[800],
    minHeight: theme.spacing(2),
    [`&.${inputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: theme.palette.primary[800]
    }
  },
  "& input": {
    fontFamily: "'Lato'",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "16px",
    letterSpacing: "0.5px",
    padding: theme.spacing(0, 0.5),
    width: "44px",
    height: "24px",
    textAlign: "center"
  },
  "& fieldset": {
    padding: 0
  }
}));
export {
  Group,
  IconContainer,
  InputGroup,
  LabelContainer,
  LoadingCircle,
  RadioButton,
  RootContainer,
  StatusLabel,
  StatusText,
  StyledTextField
};
